<template>
  <div class="main">
    <mt-header
      :title="$t('转出NFT')"
      class="dl_header_white dl_line_bottom"
      fixed
    >
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="mainbody">
      <div class="maininfo" v-if="address">
        <span>{{ $t("合约地址") }}</span>
        <!-- <input
          type="text"
          placeholder="请输入合约地址"
          :v-model.trim="address"
        /> -->
        <p style="font-weight: normal; flex: 1">
          {{ hideaddress(address) }}
        </p>
        <!-- <div>{{}}</div> -->
        <img
          src="../../assets/img/home/copy.png"
          style="width: 12px; margin-right: 20px"
          @click="nftcopy($event, 2)"
        />
      </div>
      <div class="maininfo noborder">
        <span>{{ $t("转出网络") }}</span>
        <span>{{ net }}</span>
      </div>
      <div class="maininfo">
        <span>{{ $t("藏品编号") }}</span>
        <!-- <input type="text" placeholder="请输入收藏品ID" v-model="id" /> -->
        <div class="infodetail" @click="imgpreview = true">
          <img
            :src="chooseitem.image"
            style="width: 16px; height: 16px; margin-right: 10px"
          />
          <span>{{ chooseitem.tokenid }}</span>
        </div>
        <img
          src="../../assets/img/home/dropselect1.png"
          style="width: 13px; margin-left: 10px"
          @click="getnftid"
        />
        <!-- <img
          src="../../assets/img/home/dropselect2.png"
          style="width: 13px"
          v-show="optionshow"
          @click="optionshow = !optionshow"
        /> -->
        <!-- 下拉编号选择 -->
        <!-- <div v-show="optionshow" class="selectinfo">
          <div
            v-for="item in optionselect"
            :key="item.id"
            class="selectitem"
            @click="dochoose(item)"
            v-if="item.status == 1"
          >
            {{ item.id }}
          </div>
        </div> -->
      </div>
      <div class="maininfo">
        <span>{{ $t("转出地址") }}</span>
        <input
          type="text"
          :placeholder="$t('请输入转出地址')"
          v-model.trim="to_address"
        />
      </div>

      <div class="warn">
        {{
          $t(
            "此交易属不可逆,为避免您的资产损失,请仔细核对转出地址、网络,是否准确无误。"
          )
        }}
      </div>
      <button class="btn" @click="donftout" :disabled="btncrt ? true : false">
        {{ $t("转出") }}
      </button>
      <!-- <div class="footer">
        <span style="margin-right: 20px">藏品编号</span>
        <div v-if="Object.keys(chooseitem).length > 0" class="footercenter">
          <div
            @click="popupshow = true"
            style="display: flex; align-items: center"
          >
            <img :src="chooseitem.image" style="width: 16px; height: 16px" />
            <span style="margin-left: 10px">{{ chooseitem.id }}</span>
          </div>
        </div>
        <img
          src="../../assets/img/home/dropselect1.png"
          style="width: 13px"
          alt=""
        />
      </div> -->
    </div>
    <mt-popup v-model="popupshow" position="bottom">
      <div class="nftshow" v-if="optionselect.length > 0">
        <div
          class="nftimg"
          v-for="(item, index) in optionselect"
          :key="index"
          @click="dochoose(item)"
        >
          <img
            :src="item.image"
            style="
              width: 50px;
              height: 50px;
              object-fit: cover;
              margin-right: 10px;
            "
          /><span>{{ item.tokenid }}</span>
        </div>
      </div>
    </mt-popup>
    <mt-popup v-model="imgpreview">
      <div class="imgshow">
        <img :src="chooseitem.image" alt="" /></div
    ></mt-popup>
  </div>
</template>
<script>
import handleClipboard from "@/utils/clipboard";
import { Toast, Popup } from "mint-ui";
import { outNfttokenid, outNftwithdraw } from "../../api/nft";
export default {
  data() {
    return {
      // optionshow: false,
      optionselect: [],
      address: "",
      net: "HMC",
      to_address: "",
      chooseitem: {},
      popupshow: false,
      imgpreview: false,
      btncrt: false,
    };
  },
  activated() {
    this.address = this.$route.query.contract;
    // this.net = this.$route.query.network.toUpperCase();
    this.btncrt = false;
    this.optionselect = [];
    this.to_address = "";
    this.chooseitem = this.$route.query;
  },
  methods: {
    //nft复制
    nftcopy(event, val) {
      handleClipboard(
        val,
        event,
        () => {
          Toast(this.$t("fuzhicg"));
        },
        () => {
          Toast(this.$t("fuzhicc"));
        }
      );
    },
    // 隐藏地址函数
    hideaddress(val) {
      val = val.substr(0, 6) + "**********" + val.substring(val.length - 4);
      return val;
    },
    getnftid() {
      if (this.optionselect.length > 0) {
        this.popupshow = true;
      } else {
        // 请求接口
        outNfttokenid({ contract: this.address })
          .then((res) => {
            if (res.code == 1) {
              this.optionselect.push(...res.data);
              this.popupshow = true;
            } else {
              this.popupshow = false;
            }
          })
          .catch((err) => {
            this.popupshow = false;
            return false;
          });
      }
    },
    dochoose(val) {
      this.popupshow = false;
      this.chooseitem = val;
    },
    donftout() {
      this.btncrt = true;
      outNftwithdraw({
        id: this.chooseitem.id,
        to_address: this.to_address,
      })
        .then((res) => {
          if (res.code == 1) {
            this.btncrt = false;
            Toast(res.msg);
            this.$router.push("/index");
          }
        })
        .catch((err) => {
          this.btncrt = false;
        });
    },
  },
};
</script>
<style scoped>
.main {
  box-sizing: border-box;
}
.mainbody {
  padding: 40px 14px;
}
.maininfo {
  display: flex;
  position: relative;
  align-items: center;
  padding: 28px 0;
  /* justify-content: space-between; */
  border-bottom: 1px solid #e5e5e5;
}
.selectinfo {
  position: absolute;
  top: calc(100% - 20px);
  width: 80%;
  right: 0px;
  z-index: 2;
  padding: 15px 0px;
  background-color: #fff;
  box-shadow: 0px 2px 23px 0px #e4e4e4;
}
.maininfo span {
  margin-right: 36px;
}
.maininfo input {
  flex: 1;
  vertical-align: top;
}
.dl_header_white {
  border-bottom: 1px solid #e5e5e5;
}
span {
  vertical-align: top;
  font-size: 16px;
}
.noborder {
  border-bottom: none;
}
.warn {
  font-size: 12px;
  margin-top: 20px;
  color: #f63e3e;
}
.btn {
  width: 100%;
  padding: 17px 0;
  margin-top: 16px;
  margin-bottom: 50px;
  text-align: center;
  color: #fff;
  background-color: #4492d4;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* .nftshow {
  width: 80vw;
  padding: 20px;
} */
.nftshow {
  width: 100vw;
  /* border-radius: 20px; */
  /* padding-left: 20px; */
}
.nftimg {
  padding-left: 20px;
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.footercenter {
  display: flex;
  flex: 1;
  align-items: center;
  text-align: left;
}
.selectitem {
  text-align: center;
  padding: 2px 0;
}
.infodetail {
  flex: 1;
  display: flex;
  align-items: center;
}
/deep/.mint-popup-bottom {
  border-radius: 50px 50px 0 0;
  padding: 20px;
}
.imgshow {
  width: 90vw;
  /* padding: 10px; */
}
.imgshow img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  vertical-align: bottom;
}
</style>
